import React, { useRef, useState, useEffect } from 'react';
import { Toast } from 'primereact/toast';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { Tooltip } from 'primereact/tooltip';
import { Tag } from 'primereact/tag';
import { Dialog } from 'primereact/dialog';
import { ProgressBar } from 'primereact/progressbar';
import { Dropdown } from 'primereact/dropdown';

import * as _ from 'lodash';
import { v4 as uuidv4, v4 } from 'uuid';

import { ViewService } from '../../../service/ViewService';
import { InputText } from 'primereact/inputtext';

export const FinancialPresetManager = (props) => {

    const toast = useRef(null);

    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);

    const [conciliationPresets, setConciliationPresets] = useState([]);
    const [accountigAccounts, setAccountigAccounts] = useState([]);
    const [accountigCostCenters, setAccountigCostCenters] = useState(null);
    const [financialCategories, setFinancialCategories] = useState(null);
    const [financialCostCenters, setFinancialCostCenters] = useState(null);
    const [defaultDescriptionCodes, setDefaultDescriptionCodes] = useState(null);

    const viewService = new ViewService("conciliation-presets-manager", {"customerId": props.customer.id});

    useEffect(() => {
        async function fetchData() {
            const viewData = await viewService.load();
            setAccountigAccounts((viewData.accountigAccounts || []).map(i => ({label: i.name, value: i.id})));
            setAccountigCostCenters((viewData.accountigCostCenters || []).map(i => ({label: i.name, value: i.id})));
            setFinancialCategories((viewData.financialCategories || []).map(i => ({label: i.name, value: i.id})));
            setFinancialCostCenters((viewData.financialCostCenters || []).map(i => ({label: i.name, value: i.id})));
            setDefaultDescriptionCodes((viewData.defaultDescriptionCodes || []).map(i => ({label: i.name, value: i.id})));
            setConciliationPresets(viewData.conciliationPresets || []);
            setLoading(false);
        }        
        fetchData();
    }, []);
    
    const updateItem = (itemId, field, value) => {
        let _conciliationPresets = [].concat(conciliationPresets);
        _.set(_conciliationPresets.find(i => i.id === itemId), field, value);
        setConciliationPresets(_conciliationPresets);
    }

    const add = () => {
        setConciliationPresets([].concat(conciliationPresets).concat({
            id: v4(),
            name: "",
            priority: conciliationPresets.length,
            comparison_operator: '',
            comparison_value: ''
        }));
    }

    const remove = (itemId) => {
        let _conciliationPresets = [].concat(conciliationPresets);
        _.set(_conciliationPresets.find(i => i.id === itemId), "deleted", true);
        setConciliationPresets(_conciliationPresets);
    }

    const save = async () => {

        try {
            await viewService.save({ conciliationPresets });
            props.onUpdate(conciliationPresets.filter(c => !c.deleted));
            props.onClose();    
        } catch (error) {
            console.log(error);
            toast.current.show({severity: 'error', summary: 'Ocorreu um erro', detail: error.toString()});
        }
        
    }

    const dialogFooter = (
        <>
            <Button disabled={loading || saving} label={"Re-Aplicar Regras"} icon="pi pi-tags" className="p-button-success p-mr-2" onClick={() => props.onRulesApply(conciliationPresets)} />
            <Button disabled={loading || saving} label={"Adicionar"} icon="pi pi-plus" className="p-button-success p-mr-2" onClick={add} />
            <Button disabled={loading || saving} label={"Salvar"} icon="pi pi-check" className="p-button-success p-mr-2" onClick={save} />
            <Button disabled={loading || saving} label={"Cancelar"} icon="pi pi-times" className="p-button-secondary p-mr-2" onClick={props.onClose} />
        </>
    );

    const onRowReorder = (e) => {
        console.log(e);
        let _conciliationPresets = [].concat(conciliationPresets);
        e.value.forEach((item,priority) => {
            _conciliationPresets.find(cp => cp.id === item.id).priority = priority;
        });
        setConciliationPresets(_conciliationPresets);
    }

    return (
        <>
        <Toast ref={toast}></Toast>
        <Dialog visible={true} onHide={props.onClose} style={{ width: '90vw' }} header="Pré-Configurações"
            footer={
                loading || saving ? <ProgressBar mode="indeterminate"/> : dialogFooter
            }
            modal>            
            { !loading && 
                <DataTable 
                    value={(conciliationPresets || []).filter(i => !i.deleted).sort((a,b) => a.priority > b.priority ? 1 : -1)}
                    dataKey="id"
                    style={{width: '100%', height: '600px'}}
                    onRowReorder={onRowReorder}
                    >
                        <Column rowReorder style={{width: '3em'}} />
                        <Column field="name" header="Nome" body={(data) => <InputText value={data.name} onChange={(e) => updateItem(data.id, "name", e.target.value)} style={{width: '100%'}}></InputText>}></Column>
                        <Column 
                            field="comparison_operator" 
                            header="Regra Automática" 
                            body={(data) => <>
                                <Dropdown 
                                    value={data.comparison_operator} 
                                    options={[{label: "=", value: "EQUAL"},{label: "%", value: "CONTAINS"}]} 
                                    onChange={(e) => updateItem(data.id, "comparison_operator", e.value)} 
                                    placeholder="" 
                                    style={{width: '65px'}}/>
                                <InputText
                                    value={data.comparison_value} 
                                    onChange={(e) => updateItem(data.id, "comparison_value", e.target.value)} 
                                    placeholder="" 
                                    style={{width: '80px'}}/>
                                </>
                            }>
                                
                        </Column>
                        <Column 
                            field="accounting_account_id" 
                            header="Conta Contábil" 
                            body={(data) => <Dropdown 
                                value={data.accounting_account_id} 
                                options={accountigAccounts} 
                                onChange={(e) => updateItem(data.id, "accounting_account_id", e.value)} 
                                placeholder="Selecione" 
                                style={{width: '100%'}}/>}>
                        </Column><Column 
                            field="accounting_cost_center_id" 
                            header="Centro de Custo Contábil" 
                            body={(data) => <Dropdown 
                                value={data.accounting_cost_center_id} 
                                options={accountigCostCenters} 
                                onChange={(e) => updateItem(data.id, "accounting_cost_center_id", e.value)} 
                                placeholder="Selecione" 
                                style={{width: '100%'}}/>}>
                        </Column>
                        <Column 
                            field="financial_category_id" 
                            header="Categoria Financeira" 
                            body={(data) => <Dropdown 
                                value={data.financial_category_id} 
                                options={financialCategories} 
                                onChange={(e) => updateItem(data.id, "financial_category_id", e.value)} 
                                placeholder="Selecione" 
                                style={{width: '100%'}}/>}>
                        </Column>
                        <Column 
                            field="financial_cost_center_id" 
                            header="Centro de Custo Financeiro" 
                            body={(data) => <Dropdown 
                                value={data.financial_cost_center_id} 
                                options={financialCostCenters} 
                                onChange={(e) => updateItem(data.id, "financial_cost_center_id", e.value)} 
                                placeholder="Selecione" 
                                style={{width: '100%'}}/>}>
                        </Column>
                        <Column 
                            field="default_description_code_id" 
                            header="Histórico Padrão" 
                            body={(data) => <Dropdown 
                                value={data.default_description_code_id} 
                                options={defaultDescriptionCodes} 
                                onChange={(e) => updateItem(data.id, "default_description_code_id", e.value)} 
                                placeholder="Selecione" 
                                style={{width: '100%'}}/>}>
                        </Column>
                        <Column field="id" header=""  style={{width:'100px'}} body={(data) => 
                            <Button icon="pi pi-trash" className="p-button-rounded p-button-danger" onClick={() => remove(data.id)} />
                        }/>
                </DataTable>
            }
        </Dialog>
        </>
    )
}